
import "./styles.scss"
import { observer } from 'mobx-react';
import { PPDModal } from 'pages/profile-dashboard/components/PPDModal';
import { PPDWidgetLeagueRatingSubTabs } from '../PPDWidgetLeagueRatingSubTabs';
import { PPDWidgetLeagueRatingTabs } from '../PPDWidgetLeagueRatingTabs';
import { PPDWidgetRatingLeagueList } from '../PPDWidgetLeagueRatingList';

type Props = {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    list: any[];
    activeTab: "plan" | "sales";
    activeSubtab: "leaders" | "my_place";
    onChangeTab: (tab: "plan" | "sales") => void;
    onChangeSubtab: (subtab: "leaders" | "my_place") => void;
    labels: Record<string, string>;
};

export const PPDWidgetLeagueRatingModal = observer(({
    isOpen,
    onClose,
    list,
    activeTab,
    activeSubtab,
    onChangeTab,
    onChangeSubtab,
    labels,
    title
}: Props) => {

    return (
        <PPDModal isOpened={isOpen} onClose={onClose} fullHeight={true} className="ppd-widget-league-rating-modal">
            <div className="ppd-widget-league-rating-modal__content">
                <div className="ppd-widget-league-rating-modal__header">
                    <h2 className="ppd-widget-league-rating-modal__title">{title}</h2>
                    <PPDWidgetLeagueRatingTabs
                        activeTab={activeTab}
                        onChange={onChangeTab}
                        labels={labels}
                        className="ppd-widget-league-rating-modal__tabs"
                    />
                    <p className="ppd-widget-league-rating-modal__header-text">
                        Во вкладке «План» показывается рейтинг по выполнению плана. Сотрудники, с самым большим процентом выполнения занимают лидирующие позиции
                    </p>
                    <PPDWidgetLeagueRatingSubTabs
                        activeSubtab={activeSubtab}
                        onChange={onChangeSubtab}
                        labels={labels}
                        className="ppd-widget-league-rating-modal__subtabs"
                    />
                </div>
                <div className="ppd-widget-league-rating-modal__body">
                    <PPDWidgetRatingLeagueList
                        list={list}
                        activeTab={activeTab}
                        subtab={activeSubtab}
                        className="ppd-widget-league-rating-modal__list"
                        isModal={true}
                    />
                </div>
            </div>
        </PPDModal>
    );
});
